import React from 'react'
import Header from '../../components/header/Header'
import Footer from '../../components/footer/Footer'
import ContactForm from './ContactForm'

const ContactUs = () => {
  return (
    <div>
        <Header/>
        <ContactForm/>
        <Footer/>
    </div>
  )
}

export default ContactUs